import { preferenceConstants } from "./constants/preferenceConstants";

export const getPreference = () => ({
  type: preferenceConstants.getPreferenceRequest,
}); 

const getPreferenceByPhone = (phoneNumber: string) => ({
  type: preferenceConstants.getPreferenceByPhoneRequest,
  payload: phoneNumber,
});

const savePreference = (data: any) => ({
  type: preferenceConstants.savePreferenceRequest,
  payload: data,
});

export const preferenceActions = {
  getPreference,
  getPreferenceByPhone,
  savePreference,
};
